document.addEventListener('DOMContentLoaded', () => {
    const menuDrawer = document.querySelector('header-drawer details');
    const menuIcon = document.querySelector('.mnk-navigation-bar__icon');
    const headerMenuIcon = document.querySelector('.header__icon.header__icon--menu');

    if (!menuIcon || !headerMenuIcon || !menuDrawer) return;

    menuIcon.addEventListener('click', () => {
        headerMenuIcon.click();

        setTimeout(() => {
            const isOpen = menuDrawer.hasAttribute('open');

            if (isOpen) { 
                menuIcon
                    .querySelector('.mnk-navigation-bar__icon-hamburger')
                    .classList.add('mnk-navigation-bar__icon--hidden');
                menuIcon
                    .querySelector('.mnk-navigation-bar__icon-close')
                    .classList.remove('mnk-navigation-bar__icon--hidden');
            } else {
                menuIcon
                    .querySelector('.mnk-navigation-bar__icon-hamburger')
                    .classList.remove('mnk-navigation-bar__icon--hidden');
                menuIcon
                    .querySelector('.mnk-navigation-bar__icon-close')
                    .classList.add('mnk-navigation-bar__icon--hidden');
            }
        }, 50);
    });
});
